import styled from '@emotion/styled';
import type { TrackerPrototype } from '@racemap/sdk/schema/trackers';
import { Table, Typography } from 'antd';
import type { FC } from 'react';
import { IconTrash } from 'src/components/Icon';

interface Props {
  setTrackersToAdd: (trackersToAdd: Array<TrackerPrototype>) => void;
  trackersToAdd: Array<TrackerPrototype> | null;
}

const { Text } = Typography;

export const TrackersTable: FC<Props> = ({ setTrackersToAdd, trackersToAdd }) => {
  const columns = [
    {
      title: 'Tracker Name',
      dataIndex: 'trackerName',
      key: 'trackerName',
    },
    {
      title: 'Type',
      dataIndex: 'trackerType',
      key: 'trackerId',
    },
    {
      title: 'IMEI',
      dataIndex: 'trackerId',
      key: 'trackerId',
      render: (imei: string) => (
        <Text copyable code>
          {imei}
        </Text>
      ),
    },
    {
      title: <IconTrash />,
      key: 'delete',
      width: 50,
      render: (_: any, record: TrackerPrototype) => (
        <DeleteButton
          onClick={() =>
            setTrackersToAdd(
              (prev) => prev?.filter((tracker) => tracker.trackerId !== record.trackerId) || null,
            )
          }
        />
      ),
    },
  ];

  return (
    <Table
      dataSource={trackersToAdd?.map((tracker) => ({
        ...tracker,
        key: tracker.trackerId,
      }))}
      columns={columns}
      pagination={false}
      scroll={{ y: 400 }}
      bordered
    />
  );
};

const DeleteButton = styled(IconTrash)`
  cursor: pointer;
`;
